import { Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { NavBarConfig, NavBarItemType } from '../nav-bar.config';

@Component({
	selector: 'df-nav-bar-item',
	imports: [RouterLink, RouterLinkActive],
	templateUrl: './nav-bar-item.component.html',
	styleUrl: './nav-bar-item.component.scss'
})
export class NavBarItemComponent {
	NavBarItemType = NavBarItemType;
	readonly item = input.required<NavBarConfig>();
	readonly isActive = input(false);
	readonly isMobileNav = input(false);
	readonly action = output<string>();
}
